<template>
  <div v-if="eventTypes">
    <h1>Event Types</h1>
    <v-switch label="Show archived" v-model="archived" />
    <v-btn :to="{ name: 'eventTypeAdd' }">
      <v-icon>add</v-icon>Event type
    </v-btn>
    <v-btn @click="updateVisibility()" v-if="$keycloak.hasRealmRole('root')"
      >Update visibility</v-btn
    >
    <v-data-table
      :headers="headers"
      :items="eventTypes"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'eventType', params: { id: props.item.id } }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.help }}</td>
          <td>
            <v-chip
              small
              v-for="department in props.item.departments"
              :key="department.id"
              >{{ department.name }}</v-chip
            >
          </td>
          <td>
            <v-chip
              small
              v-for="category in props.item.categories"
              :key="category.id"
              >{{ category.shortname }}</v-chip
            >
          </td>
          <td>
            <v-chip small v-for="role in props.item.roles" :key="role.id">{{
              role.name
            }}</v-chip>
          </td>
          <td>
            <v-btn @click="deleteEventType(props.item)">
              <span v-if="props.item.archived">Unarchive</span>
              <span v-if="!props.item.archived">Archive</span>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EventTypes",
  metaInfo() {
    return {
      title: "Event types",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      eventTypes: null,
      archived: false,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Help",
          value: "help"
        },
        {
          text: "Departments",
          sortable: false
        },
        {
          text: "Categories",
          sortable: false
        },
        {
          text: "Roles",
          sortable: false
        },
        {
          text: " ",
          sortable: false
        }
      ]
    };
  },
  methods: {
    async fetchEventTypes() {
      const response = await nbmlaw.get(`/cors/admin/file/eventTypes`, {
        params: { archived: this.archived }
      });
      // console.log(response.data);
      this.eventTypes = response.data;
    },
    async deleteEventType(eventType) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/file/eventTypes/${eventType.id}`, {
          params: { archived: this.archived }
        });
        // console.log(response.data);
        this.update();
      }
    },
    async updateVisibility() {
      if (confirm("Are you sure?")) {
        await nbmlaw.post(`/cors/admin/file/eventTypes/visibility`);
        this.update();
      }
    },
    update() {
      this.fetchEventTypes();
    }
  },
  watch: {
    archived: {
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.update();
  }
};
</script>